/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Your_CodeInputs */

const en_mobile_referral_your_code = /** @type {(inputs: Mobile_Referral_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your code`)
};

const es_mobile_referral_your_code = /** @type {(inputs: Mobile_Referral_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu código`)
};

/**
* | output |
* | --- |
* | "Your code" |
*
* @param {Mobile_Referral_Your_CodeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_your_code = /** @type {((inputs?: Mobile_Referral_Your_CodeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Your_CodeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_your_code(inputs)
	return en_mobile_referral_your_code(inputs)
});